<template>
    <div v-show="panel_required">
        <tile-question-layout
            :target="localTarget"
            @update:target="$emit('update:target', $event)"
            :options_loaded="options_loaded"
            :passed_filter="passed_filter"
            :title="title"
            :loading="loading"
            :filtered_option_list="filtered_option_list"
            :thumb_url="thumbURL"
            :component_id="component_id"
            :fabricator="fabricator"
            :has_popup_info="has_popup_info"
            :popup_info_title_html="popup_info_title_html"
            :popup_info_inner_html="popup_info_inner_html"
            :extra_text="extra_text"
            :floating_sidebar_message="floating_sidebar_message"
            :modifier_class="modifier_class"
            :show_empty_tiles="show_empty_tiles"
            :search-filter="filterSearch"
            @update:search-filter="$emit('update:search-filter', $event)"
            :component-filter-box="componentFilterBox"
            :helper_text="helper_text"
        ></tile-question-layout>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            fabricator: {
                required: true,
            },
            has_popup_info: {
                default() {
                    return false;
                }
            },
            popup_info_title_html: {
                default() {
                    return '';
                }
            },
            popup_info_inner_html: {
                default() {
                    return '';
                }
            },
            extra_text: {
                default() {
                    return '';
                }
            },
            floating_sidebar_message: {
                default() {
                    return '';
                }
            },
            modifier_class: {
                required: false,
            },
            title: {
              required: false,
            },
            show_empty_tiles: {
              default(){
                return true;
              }
            },
            component_id: {
              required: false,
            },
            filterSearch: {
                default() {
                    return '';
                }
            },
            componentFilterBox: {
                default() {
                    return false;
                }
            },
            helper_text: {
                default() {
                    return false;
                }
            },
        },
        computed: {
            filtered_option_list() {
                if (this.option_list === null) {
                    return [];
                }

                if (!Array.isArray(this.option_list)) {
                    return [];
                }

                return this.option_list.filter((key) => {
                    return key.value !== null && !!key.value && (~key.label.toLowerCase().indexOf(this.filterSearch.toLowerCase()) || key.value === this.localTarget);
                });
            },
        }
    }
</script>
